
import { Component, Vue, Watch } from 'vue-property-decorator';

import store from '@/store';

import BoxContainer from '@/components/BoxContainer/BoxContainer.vue';
import AvatarRanking from '@/components/AvatarRanking/index.vue';
import FeedbackUser from '@/components/FeedbackUser/index.vue';
import Tabs, { TabsMenuInterface } from '@/components/Tabs/Tabs.vue';
import RankingUser from '@/pages/Ranking/components/RankingUser/RankingUser.vue';

import RankingLoading from './RankingLoading.vue';

import Joystick from '@/assets/icons/ranking/Joystick.vue';

import GamificationService from '@/services/Gamification/gamificationService';

import { RankingData, User, RankingMonth } from '@/globalInterfaces/Gamification';

import { NAME_ROUTES_RANKING } from '@/router/routes/Ranking';

import { TABS, TAB_NAME_GENERAL } from './constants';

@Component({
  components: {
    BoxContainer,
    AvatarRanking,
    RankingLoading,
    RankingUser,
    Joystick,
    FeedbackUser,
    Tabs
  },
  filters: {
    formatName(user: User) {
      if (!user) return '';

      const { idstudent } = store.getters.profile;
      const userName = user.nickname || user.name;

      const splitName = userName.split(' ');

      if (idstudent && user.ID === idstudent) return `${splitName[0]} (você)`;

      return splitName[0];
    },
    formatPosition(value: number) {
      return value > 100 ? '100+' : `${value}`;
    }
  }
})
export default class Ranking extends Vue {
  private isLoadingRanking = true;
  private userBelowTopFive = false;
  private errorRanking = false;

  private userDataRanking: RankingData | null = null;

  private ranking: RankingData[] = [];
  private tabs: TabsMenuInterface[] = TABS.map((tab) => ({
    ...tab,
    title: this.$t(tab.title).toString()
  }));

  private GamificationService = new GamificationService();

  created() {
    this.getMonthlyRanking();
  }

  get profile() {
    return this.$store.getters.profile;
  }

  get idStudent() {
    return this.profile?.idstudent;
  }

  get activeTabIsGeneral() {
    return this.tabs.find((tab) => tab.active)?.title === this.$t(TAB_NAME_GENERAL);
  }

  @Watch('tabs')
  getRankingByActiveTab() {
    if (this.activeTabIsGeneral) this.getGeneralRanking();
    else this.getMonthlyRanking();
  }

  async getGeneralRanking() {
    try {
      this.isLoadingRanking = true;

      const ranking = await this.GamificationService.getRanking();

      if (ranking?.ranking.length) {
        const isUserInRanking = this.findUserRanking(ranking?.ranking);

        if (!isUserInRanking) {
          const userRanking = await this.GamificationService.getUserRanking();

          ranking.ranking.push(userRanking);
        }
      }

      this.ranking = this.setRanking(ranking?.ranking);
    } catch (error) {
      this.errorRanking = true;

      this.$store.dispatch('Toast/setToast', {
        text: this.$t('ranking.errors.loadingGeneral'),
        status: 'error'
      });

      console.error(error);
    } finally {
      this.isLoadingRanking = false;
    }
  }

  async getMonthlyRanking() {
    try {
      const newRanking = [];

      this.isLoadingRanking = true;

      const currentMonth = new Date().getMonth() + 1;

      const data = {
        quantity: 5,
        month: currentMonth
      };

      const ranking = await this.GamificationService.getUserRankingMonth(data);

      if (ranking?.length) {
        newRanking.push(...this.setDataMonthlyRanking(ranking));

        const isUserInRanking = this.findUserRanking(newRanking);

        if (!isUserInRanking) {
          const userRanking = await this.GamificationService.getMeRankingMonth({
            month: currentMonth
          });

          const newUserRanking = this.setDataMonthlyRanking(userRanking);

          newRanking.push(...newUserRanking);
        }

        this.ranking = this.setRanking(newRanking);
      }
    } catch (error) {
      this.errorRanking = true;

      this.$store.dispatch('Toast/setToast', {
        text: this.$t('ranking.errors.loadingMonthly'),
        status: 'error'
      });

      console.error(error);
    } finally {
      this.isLoadingRanking = false;
    }
  }

  setDataMonthlyRanking(ranking: RankingMonth[]) {
    return ranking.reduce((acc: RankingData[], currentRanking: RankingMonth) => {
      acc.push({
        ID: currentRanking.ID,
        points: currentRanking.points,
        ranking: currentRanking.position,
        month_index: currentRanking.position,
        year_index: currentRanking.position,
        month_points: currentRanking.points,
        created_date: '',
        updated_date: '',
        level: currentRanking.level,
        user: currentRanking.user
      });

      return acc;
    }, []);
  }

  setRanking(ranking: RankingData[]) {
    const newRanking = ranking.filter((userPlacement: RankingData) => {
      if (userPlacement.user.ID === this.idStudent) {
        if (userPlacement.ranking > 5 || userPlacement.ranking === undefined) {
          this.userBelowTopFive = true;
        }

        this.userDataRanking = userPlacement;
      }

      return !this.userBelowTopFive || this.userDataRanking?.user.ID !== userPlacement.user.ID;
    });

    return newRanking;
  }

  findUserRanking(ranking: RankingData[]) {
    const userRanking = ranking.find((user) => user.user.ID === this.idStudent);

    return userRanking;
  }

  redirectPageRanking() {
    this.$router.push({
      name: NAME_ROUTES_RANKING.RANKING
    });
  }

  changeTabActive(index: number, updatedTabs: Array<TabsMenuInterface>) {
    this.tabs = updatedTabs;
  }
}
